export default function HistoryServiceProvider() {
  this.$get = ($location, $rootScope, $timeout) => {
    'ngInject';

    let history = [];
    let needChange = true;

    $rootScope.$on('$locationChangeSuccess', () => {
      if (!needChange) {
        needChange = true;
        return;
      }

      if (history.length > 0 && history[history.length - 1].path == $location.$$path) {
        history[history.length - 1].params = $location.$$search;
        history[history.length - 1].url = $location.$$url;
      } else {
        history.push({
          path: $location.$$path,
          params: $location.$$search || {},
          url: $location.$$url
        });
      }
      if (history.length > 100) {
        history = history.slice(1, history.length);
      }
    });

    function HistoryService() {

      const self = this;

      self.getPrevUrl = altUrl => history.length > 1 ? history[history.length - 2].url : altUrl;

      self.onBack = () => {
        needChange = false;
        $timeout(() => history.splice(-1));
      };

      self.back = (altUrl, altParams) => {
        if (history.length > 1) {
          const prevPage = history[history.length - 2];
          history = history.slice(0, history.length - 1);
          $location.path(prevPage.path).search(prevPage.params);
          return;
        }

        const path = $location.path(altUrl);
        if (altParams) {
          path.search(altParams);
        }
        history = history.slice(0, history.length - 1);
      };

      self.clear = () => history = [];

    }

    return new HistoryService();
  };
}